// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"18dfbba0","433":"c516b747","908":"8429869b"}[chunkId] + ".chunk.js";
};